import { getCarpeeshHandoverWizardPages } from './carpeesh_handover_wizard_pages';
import { getKobaHandoverWizardPages } from './koba_handover_wizard_pages';

const getHandoverWizardPages = (providerCode, productDisclosures) => {
    const getPages = customerHandoverProviders[providerCode && providerCode.toUpperCase()];
    return getPages && getPages.call(this, productDisclosures);
};

const isSupportHandoverWizard = (providerCode) => providerCode && Object.keys(customerHandoverProviders).includes(providerCode);

const customerHandoverProviders = {
    CARP: getCarpeeshHandoverWizardPages,
    KOBA: getKobaHandoverWizardPages
};

export { getHandoverWizardPages, isSupportHandoverWizard, customerHandoverProviders };
